
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discuss/[discussid]",
      function () {
        return require("private-next-pages/discuss/[discussid].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discuss/[discussid]"])
      });
    }
  